import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DISPLAY_AGREEMENT_COLUMNS } from '../../constants/agreement.constant';
import { column_order, RATE_AGREEMENT_TABLE } from '../../interfaces/rate-information.interface';
import { AppService } from 'src/app/app.service';
import { TableService } from '../../services/tableService/table.service';
import { MatSelect } from '@angular/material/select';
import { DatePipe } from '@angular/common';
import { HttpService } from '../../services/http.service';
import { BsDaterangepickerDirective } from 'ngx-bootstrap/datepicker';
import { BsDropdownState } from 'ngx-bootstrap/dropdown';
import * as moment from 'moment';
import { DateRange } from 'igniteui-angular';

// interface DateRange {
//   start: Date;
//   end: Date;
// }

@Component({
  selector: 'app-rate-agreement-table',
  templateUrl: './rate-agreement-table.component.html',
  styleUrls: ['./rate-agreement-table.component.scss']
})


export class RateAgreementTableComponent implements AfterViewInit {
  @Input() isLandingPage= false;
  public contactTableForm: FormGroup = new FormGroup({});
  displayedColumns: any;
  dataSource = new MatTableDataSource<RATE_AGREEMENT_TABLE>();
  filteredValues: any = { topFilter: false };
  actualData =new MatTableDataSource<RATE_AGREEMENT_TABLE>();
  searchItems: any = [];
  allSelected = false;
  selectedItemforDownload=[]
  options: any = {
    locale: { format: 'DD/MM/YYYY' },
    alwaysShowCalendars: false,
  };
  
  totalRecord = 200
  currentRecord = 10
  currentPage = 1;
  pageSize: number = 5;
  goToPageNumber: number  = 1;
  userData:any;
  dataColList:any;

  // startIndex: number=0;
  // endIndex: number =0;

  @ViewChild(MatSort) sort: MatSort | any;
  @ViewChild(MatPaginator) paginator: MatPaginator | any;
  @ViewChild('searchInput', { static: false }) searchInput: ElementRef | any;
  @ViewChild(MatSelect) matSelect!: MatSelect;
  @ViewChild('daterangepicker', { static: false }) daterangepicker!: BsDaterangepickerDirective;
  selectedDate:any;
  dateRange: Date[] = [];
  customClasses: any = [];
  public range: DateRange = { start: new Date(), end: new Date(new Date().setDate(new Date().getDate() + 5)) };

  bsConfig:any = {
    rangeInputFormat: 'DD/MM/YYYY', // Display format for the input field
    dateInputFormat: 'DD/MM/YYYY', // Internal date format
    isAnimated: true,              // Enables animation for the picker
    showWeekNumbers: false,        // Optionally hide week numbers
    containerClass: 'custom-1', // Bootstrap theme styling
    selectFromOtherMonth: true,
    datesDisabled: [],
    dateCustomClasses: [],
    displayMonths: 1,
  };
  
  
  activePicker: string | null = null;

  // To store selected date ranges
  EffectiveDateRange: any=''
  ExpiryDateRange: any=''
  createdOnDate: any;
  modifiedOnDate: any;
  intialDateValue: any;

  constructor(public dialog: MatDialog, private router: Router, private fb: FormBuilder, 
    public appService:AppService,public tableService:TableService, private datePipe:DatePipe, 
    private dropdownState: BsDropdownState,private httpService:HttpService) {
     setTimeout(() => {
      let userData = sessionStorage.getItem("user-data");
      this.userData = userData?JSON.parse(userData):null;
      this.tableService.tableDataGetList('rate-agreement',this);  
     }, 1000);

      this.tableService.displayColumUpdate.subscribe((obj:any)=>{
        if(obj === "RateAgreement"){
          this.appService.isLoading = false;
          this.dataColList = this.tableService.getTableColNames(this.displayedColumns)            
          this.contactTableForm = this.fb.group({});
          this.dataColList?.forEach((ele:any) => {
          this.filteredValues[ele] = '';          
          this.contactTableForm.addControl(ele + "Filter", new FormControl(''));
          this.contactTableForm.get("RateAgreementStatusFilter")?.setValue(['Draft', 'Active']);          
          this.tableService.checkWithFilter(this)          
        })
        setTimeout(() => {          
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.tableService.checkWithFilter(this);
          
        },1100);
      }})
  }

  toggleDatePicker(columnName: string, show: boolean = true) {
    this.activePicker = show ? columnName : null;
  }

  onDateSingleSelected(name:string, e: any) {
    // const  formattedDate =e.startDate.format('YYYY-MM-DD')+"@"+e.endDate.format('YYYY-MM-DD')
    // this.contactTableForm.get(`${name}Filter`)!.setValue(e.startDate.format('DD/MM/YYYY') + ' - ' + e.endDate.format('DD/MM/YYYY'));
    // if(name === 'ExpiryDate'){
    //   this.ExpiryDateRange = e.startDate.format('DD/MM/YYYY') + ' - ' + e.endDate.format('DD/MM/YYYY')
    // }
    // else{
    //   this.EffectiveDateRange = e.startDate.format('DD/MM/YYYY') + ' - ' + e.endDate.format('DD/MM/YYYY')
    // }
    // if (this.contactTableForm.get(`${name}Filter`)) {
    //   this.contactTableForm.get(`${name}Filter`)!.patchValue(formattedDate);
    // }
    this.toggleDatePicker(name, false);
  }

  onDateSelected(name:string, e: any) {
    const  formattedDate =e.startDate.format('YYYY-MM-DD')+"@"+e.endDate.format('YYYY-MM-DD')
    this.contactTableForm.get(`${name}Filter`)!.setValue(e.startDate.format('DD/MM/YYYY') + ' - ' + e.endDate.format('DD/MM/YYYY'));
    if(name === 'ExpiryDate'){
      this.ExpiryDateRange = e.startDate.format('DD/MM/YYYY') + ' - ' + e.endDate.format('DD/MM/YYYY')
    }
    else{
      this.EffectiveDateRange = e.startDate.format('DD/MM/YYYY') + ' - ' + e.endDate.format('DD/MM/YYYY')
    }
    if (this.contactTableForm.get(`${name}Filter`)) {
      this.contactTableForm.get(`${name}Filter`)!.patchValue(formattedDate);
    }
    this.toggleDatePicker(name, false);
  }

  onDatesUpdated(name:string, e: any, picker: string) {
    this.contactTableForm.get(`${name}Filter`)?.setValue(null, { emitEvent: false }); // Clear the value temporarily
    const  formattedDate =e.startDate.format('YYYY-MM-DD')+"@"+e.endDate.format('YYYY-MM-DD')
    this.contactTableForm.get(`${name}Filter`)!.setValue(e.startDate.format('DD/MM/YYYY') + ' - ' + e.endDate.format('DD/MM/YYYY'));
    if(name === 'ExpiryDate'){
      this.ExpiryDateRange = e.startDate.format('DD/MM/YYYY') + ' - ' + e.endDate.format('DD/MM/YYYY')
    }
    else{
      this.EffectiveDateRange = e.startDate.format('DD/MM/YYYY') + ' - ' + e.endDate.format('DD/MM/YYYY')
    }
    if (this.contactTableForm.get(`${name}Filter`)) {
      this.contactTableForm.get(`${name}Filter`)!.patchValue(formattedDate);
    }
    this.toggleDatePicker(picker, false);
  }

  matDateRangePicker(picker: any,name:string) {
    picker.open();
  }

  onDateChange(evt:any,name:string){
    if(name === 'CreatedOn'){
    this.createdOnDate = evt.value;
    }
    else if(name === 'ModifiedOn'){
      this.modifiedOnDate = evt.value;
    }
    else if(name === 'InitialContractEffectiveDate'){
      this.intialDateValue = evt.value;
    }
    this.contactTableForm.get(`${name}Filter`)!.patchValue(this.appService.formatDate(evt.value));
  }

  resetDateFilter(){
    this.EffectiveDateRange = null;
    this.ExpiryDateRange = null;
    this.createdOnDate= null;
    this.modifiedOnDate = null;
    this.intialDateValue = null;
  }

  onDateRangeChange(evt:any,name:string){
    this.contactTableForm.get(`${name}Filter`)!.patchValue(this.appService.formatDate(evt.value));
  }

  ngAfterViewInit() {
    // ['version','attachment'].forEach((i:any) =>{        
    //   this.httpService.onClearFolder(i)
    //   .subscribe((res:any) =>{})
    // })
    this.appService.onRAvalueChanged = false;
    this.pageSize = this.tableService.rateTablePageCount;
    if (this.daterangepicker) {
      this.daterangepicker.bsValueChange.subscribe((e: any) => console.log(e));
    }
    
  }
  @HostListener('document:click', ['$event'])
  onOutsideClick(event: Event): void {
    const target = event.target as HTMLElement;
    const activePickers = ['#expritydatefilter','#EffectiveDate','#ExpiryDate', '#effectivedatefilter'];
    const isOutside = !activePickers.some((id) => target.closest(id));
    if (isOutside && (this.activePicker ==='EffectiveDate' || this.activePicker ==='ExpiryDate')) {
      this.activePicker = null;
    }
  }

  onDateRageChange(e:any,name?:string){ 
    // console.log("eee",e,name, document.getElementsByClassName('bs-datepicker-body'));
    // const startDateInput = document.getElementsByClassName('select-start')[0]
    // console.log(startDateInput);
    
    if(!e){
      this.contactTableForm.get(`${name}Filter`)!.setValue(undefined);
      this.dataSource.filter = "".trim().toLowerCase();
      return
    }
    this.dateRange = e;
    const startDate = e[0];
    const inputElement = this.contactTableForm.get(`${name}Filter`)!;
    inputElement.setValue(startDate.toLocaleDateString());
    // this.updateDateRangeCustomClasses();    
    const  formattedDate =this.appService.dateFormate(e[0])+"@"+this.appService.dateFormate(e[1])
    // // this.contactTableForm.patchValue({[e.name]: formattedDate})
    if (this.contactTableForm.get(`${name}Filter`)) {
      this.contactTableForm.get(`${name}Filter`)!.patchValue(formattedDate);
    }
  }
  
  updateDateRangeCustomClasses(): void {
    this.customClasses = [];
    if (this.dateRange.length > 0) {
      // Highlight the start and end dates
      const [startDate, endDate] = this.dateRange;

      if (startDate) {
        this.customClasses.push({ date: startDate, classes: ['custom-highlighted'] });
      }
      if (endDate) {
        this.customClasses.push({ date: endDate, classes: ['custom-highlighted'] });
      }
    }
    const currentConfig = { ...this.bsConfig }; // Backup the current config
    this.bsConfig = null; // Temporarily set to null
    setTimeout(() => {
      this.bsConfig = {
        ...currentConfig,
        dateCustomClasses: this.customClasses
      };
    }, 0); // Reassign after a brief delay
  }

  onDaetChange(e:any,name?:string){
    if(!e){
      this.contactTableForm.get(`${name}Filter`)!.setValue(undefined);
      this.dataSource.filter = "".trim().toLowerCase();
      return
    }
    
    const  formattedDate =this.appService.dateFormate(e)
    // this.updateCustomClasses(e);
    // this.contactTableForm.patchValue({[e.name]: formattedDate})
    if (this.contactTableForm.get(`${name}Filter`)) {
      this.contactTableForm.get(`${name}Filter`)!.patchValue(formattedDate);
    }
    // this.contactTableForm.get(e.name)?.setValue('kaali', { emitEvent: false });
    
    
  }

  updateCustomClasses(selectedDate:Date): void {
    const customClasses = [selectedDate].map((date:any) => ({
      date: date, // Ensure this is a Date object
      classes: ['custom-highlighted'] // Custom class for styling
    }));

    this.tableService.bsConfig = {
      ...this.tableService.bsConfig,
      dateCustomClasses: customClasses // Update with new custom classes
    };
  }
  
  onViewAllCall(){
    this.appService.mineBtnEbaled = false;
    this.router.navigateByUrl('/home/rate-agreement');
  }

  onSelectChange(str: any, i: any,enclosingObj:any) {
    // this.dataSource.data = []
    // this.filteredValues['RateAgreementStatus']=i.value !='all' ? i.value : ''
    // this.dataSource.filter=JSON.stringify(this.filteredValues)
    
    // this.contactTableForm.get(`RateAgreementStatusFilter`)!.setValue(i.value !='all' ? i.value : '' );
  }
  onKeyDown(event: KeyboardEvent, condition=false) {
    if(condition)
      return;
    event.preventDefault();
  }

  add(event: any): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      this.searchItems.push({ name: value.trim() });
    }
    if (input) {
      input.value = '';
    }
  }
  remove(item: any): void {
    const index = this.searchItems.indexOf(item);
    if (index >= 0) {
      this.searchItems.splice(index, 1);
    }
  }
  
  onAllAndMinSelection(mineBoo:Boolean) {
    this.appService.mineBtnEbaled = mineBoo;
    this.appService.mineBtnEmit.emit('')
    this.tableService.tableDataGetList('rate-agreement',this);
   }

  onViewEditItem(operation:any,item: any, id:any) {
    if(operation !="add"){
      let selected = this.actualData.data.find((i:any)=> i.RateAgreementID === item.RateAgreementID);
      this.router.navigateByUrl('/home/rate-agreement/edit-agreement', {state:{operation:operation, data:selected}})
    }
    else{
      this.appService.raIsLoading = false;
      this.router.navigateByUrl('/home/rate-agreement/edit-agreement', {state:{operation:operation, data:item}})
    }
  }

  getCurrentRecordCount(): number {
    let val = this.paginator ? this.paginator?.pageIndex + 1 : 0;
    if(val*this.pageSize > this.dataSource.data.length){
      return this.dataSource.data.length%this.pageSize;
    }
    return this.pageSize;
  }

  getPageCount(): number {
    return Math.ceil(this.dataSource.data.length / this.pageSize);
  }

  onFileDownload() {
    let data =this.dataSource.data.filter(data=>data.Selected).map((item:any)=>({
      ...item,
      'CreatedOn':this.tableService.checkOnInvalidDate(item.CreatedOn),
      'ModifiedOn':this.tableService.checkOnInvalidDate(item.ModifiedOn),
      'EffectiveDate':this.appService.onDateFromTimeZone(item.EffectiveDate),
      'ExpiryDate':this.appService.onDateFromTimeZone(item.ExpiryDate),
      'InitialContractEffectiveDate':this.appService.onDateFromTimeZone(item.InitialContractEffectiveDate),
    }));
    this.tableService.exportToExcel(data, column_order , 'RateAgreementTable');
   }
}

